import { render, staticRenderFns } from "./dashboardindicadores.vue?vue&type=template&id=0f1f6278&"
import script from "./dashboardindicadores.vue?vue&type=script&lang=js&"
export * from "./dashboardindicadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports